import { identifiersByType } from '../data/activity_types';
import { maxAttemptsByType } from '../data/activities_max_attempts';

export const updateAnswers = (answers, identifier, newAnswer) => {
  const newAnswers = [...(answers || [])];

  if (!identifier || !newAnswer || !newAnswer[identifier]) {
    return newAnswers;
  }

  const answerIndex = answers.findIndex(
    answer => answer[identifier] === newAnswer[identifier] && answer.bookAttempts === newAnswer.bookAttempts,
  );

  const start = answerIndex < 0 ? answers.length : answerIndex;
  const deleteCount = answerIndex < 0 ? 0 : 1;

  newAnswers.splice(start, deleteCount, newAnswer);

  return newAnswers;
};

export const formatAnswers = (answers, identifier) => {
  if (!identifier || !answers || !answers.length) {
    return answers;
  }

  const data = answers.reduce((acc, answer) => {
    const id = `${answer[identifier]}_${answer.bookAttempts}`;

    if (acc[id]) {
      const { attempts } = acc[id];

      if (attempts <= answer.attempts) {
        return {
          ...acc,
          [id]: answer,
        };
      }

      return acc;
    }

    return {
      ...acc,
      [id]: answer,
    };
  }, {});

  return Object.values(data);
};

export const findActivityAttempts = (answers, { identifier = 'activityId', id, bookAttempts } = {}) => {
  const currentAnswer =
    (answers || []).find(
      answer => identifier && answer[identifier] === id && answer.bookAttempts === bookAttempts,
    ) || {};

  return currentAnswer.attempts;
};

export const isActivityCompleted = (answers, { activityType, activityId }) => {
  const identifier = identifiersByType[activityType] || 'activityId';

  return answers.some(answer => activityId === answer[identifier] &&
     (answer.correct || answer.attempts >= (maxAttemptsByType[activityType] || 1)));
};
